import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Quote from './icon-quote.svg';

type Props = {
    fill?: string;
    color?: string; // Add new cards pass color prop
};
function SvgComponent(props: Props) {
    const iconColor = props.color || props.fill || 'white';
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <Quote {...validProps} color={iconColor} />;
}
SvgComponent.iconName = 'quote';

/**
 * @deprecated This is a legacy icon
 */
export const QuoteIcon = svgIconWrapper(SvgComponent);
